import { render, staticRenderFns } from "./RolesCreate.vue?vue&type=template&id=45479c45"
import script from "./RolesCreate.vue?vue&type=script&lang=js"
export * from "./RolesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports